import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { SectionA } from "../../components";
import NavBar from "../../components/Nav/NavBar";

function ServiceDetail() {
  const location = useLocation();
  const data = JSON.parse(location?.state);
  return (
    <Container style={{ padding: 0, overflow: "hidden" }} fluid>
      <Row>
        <Col>
          <NavBar color={"#a9a9a9"} />
          <div className="service_s1">
            <div>
              <h1 className="heading1">{data?.title}</h1>
              <p className="text_s1">Your Vision, Our Expertise</p>
            </div>

            <div className="button_s1">
              <button className="btn btn-primary">Let's Talk</button>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default ServiceDetail;
